import styled from 'styled-components';

export const StyledScreenControls = styled.section`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 16px 35px;
`;
